import { useEffect } from 'react';
import { useBrand } from '@/shared/brand/useBrand';
import { EmptyState } from '@/shared/components/EmptyState';
import { PageHeader } from '@/shared/components/PageHeader';
import type { IconName } from '@/shared/components/ui/Icon';
import { useI18n } from '@/shared/i18n/useT';
import type { MessageKey } from '@/shared/i18n/messages';

interface Props {
  icon: IconName;
  titleKey: MessageKey;
  descriptionKey: MessageKey;
}

/** Scaffold screen for procalendar.app. Replaced as each flow is built. */
export function ClientPlaceholder({ icon, titleKey, descriptionKey }: Props) {
  const { t } = useI18n();
  const brand = useBrand();
  const title = t(titleKey);

  useEffect(() => {
    document.title = `${title} · ${brand.name}`;
  }, [title, brand.name]);

  return (
    <>
      <PageHeader title={title} description={t(descriptionKey)} />
      <EmptyState
        icon={icon}
        title={t('empty.comingSoonTitle')}
        body={t('empty.comingSoonBody', { module: title })}
      />
    </>
  );
}
